import React from 'react'
import PropTypes from 'prop-types'

import { Box, Flex } from 'ui/acro'

const SubscribeContainer = ({ children, ...rest }) => (
  <Flex
    justifyContent='center'
    mx={['20px', null, 'auto']}
    mt={['27px', null, '34px']}
    {...rest}
  >
    <Box
      width='100%'
      maxWidth='490px' // This number is set by design spec.
      mx={[null, null, '50px']} // This lets us set an effective min-gutter width
    >
      {children}
    </Box>
  </Flex>
)

SubscribeContainer.propTypes = {
  children: PropTypes.node
}

export default SubscribeContainer
